import { useRef, useCallback, useState } from 'react';
import { useHistory } from "react-router-dom";
import CameraIcon from '@material-ui/icons/Camera';
import Container from '@material-ui/core/Container';
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowLeft from "@material-ui/icons/ArrowLeft";
import ArrowRight from "@material-ui/icons/ArrowRight";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Snackbar from "@material-ui/core/Snackbar";
import Webcam from 'react-webcam';

import { useAuthDispatch } from '../contexts/AuthContext';
import useStyles from "../styles/index";
import useSelfieStyles from "../styles/selfieStyles";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';


const SelfieImage = () => {


    const classes = useStyles();
    const selfieClasses = useSelfieStyles();
    const webcamRef = useRef<any>(null);
    const history = useHistory();
    const dispatch = useAuthDispatch();


    const [image, setImage] = useState<string>('');
    const [showSnack, setShowSnack] = useState(false);
    const [openDialog, setOpenDialog] = useState(true);




    const handleCapture = useCallback(
        () => {

            if (webcamRef && webcamRef.current) {


                const imageSrc = webcamRef.current.getScreenshot();

                setImage(imageSrc);

            }


        },
        [webcamRef]
    );


    const clear = () => {

        setImage('');
    };


    const next = () => {
        if (image.length > 0) {

            dispatch({
                type: "SET_SELIFIE_IMAGE",
                selfieImg: image
            });

            history.replace("/selectAuthType");

        } else {
            setShowSnack(true);
            return;

        }



    };


    return (
        <>
            <div className={classes.root}>

                <Container className={classes.content}>


                    <div className={classes.inputsContainer}>

                        <div className={classes.inputContainer} >
                        {<HelpOutlineOutlinedIcon style = {{ fontSize: "3.5em" }} className={'qutation__icon'} onClick={() => setOpenDialog(true)} />}


                            <Webcam
                                className={selfieClasses.video}
                                ref={webcamRef}
                                mirrored={true}
                                // screenshotFormat='image/jpeg'
                                screenshotFormat='image/png'
                                videoConstraints={{
                                    width: { min: 640, ideal: 1920 },
                                    height: { min: 400, ideal: 1080 },
                                    facingMode: "user",
                                }}
                            />
                            <img
                                className={selfieClasses.frame}
                                src={image.length > 0 ? image : "./frame.png"}
                                alt="frame"
                            />
                            <CameraIcon className={'icon__capture'} onClick={handleCapture} />
                        </div>


                    </div>
                    <Typography align="center" variant="caption" style={{ paddingTop: '4px' }}>
                        کلیه حقوق سامانه احراز هویت دیجیتال ویدا متعلق به شرکت کیاهوشان است.
                    </Typography>
                    {/* <Typography align="center" variant="caption" style={{ paddingTop: '4px', fontWeight: 'bold' }}>
                        مرکز تماس  پشتیبانی قوه قضائیه: 57798000 -021

                    </Typography> */}

                    <Typography align="center" variant="caption" style={{ paddingTop: '4px', fontWeight: 'bold' }}>
                                مرکز تماس پشتیبانی احراز هویت هوشمند ویدا: 66066142 -021
          </Typography>

                    <div className={classes.actionBar}>

                        <Button
                            variant="outlined"
                            color="primary"
                            className="last"
                            startIcon={image.length > 0 ? <DeleteIcon /> : <ArrowRight />}
                            onClick={image.length > 0 ? clear : () => history.push('signature')}
                        >
                            {image.length > 0 ? 'حذف' : 'قبلی'}
                        </Button>

                        <Button
                            variant="outlined"
                            color="primary"
                            endIcon={<ArrowLeft />}
                            onClick={next}
                        >
                            مرحله بعد
                        </Button>

                    </div>




                </Container>


            </div>


            <Dialog open={openDialog}>

                <DialogTitle id="simple-dialog-title">راهنمای اخذ عکس سلفی برای پروفایل حساب کاربری سامانه ثنا</DialogTitle>
                <DialogContent>
                    <ul>
                       <li>
                            <DialogContentText className={classes.justifyText}>
                                می بایست عکس به صورت سلفی، هم اکنون گرفته شود. عکسبرداری از تصاویر قبلی مورد تائید نیست.
                            </DialogContentText>
                        </li>

                        <li>
                            <DialogContentText className={classes.justifyText}>
                                لطفا دوربین را <b style={{ color: 'red' }}>مستقیم</b>  و در راستای صورت خود نگه داشته و یک عکس سلفی بگیرید (سر خود را خم نکنید).
                            </DialogContentText>
                        </li>
                        <li>
                            <DialogContentText className={classes.justifyText}>
                            در صورتی که سیستم شما فاقد دوربین است می توانید مجددا مراحل را از ابتدا، با دستگاه موبایل و از طریق سایت قوه قضائیه به آدرس  <a href="https://sana.adliran.ir/" rel="noreferrer"> https://sana.adliran.ir </a> و <b style={{ color: 'red' }}>بدون پرداخت هزینه</b> تکرار کنید.                            </DialogContentText>
                           
                           
                            </li>
                        <br/>
              

                        <b style={{ fontSize: '18px', color: 'red' }}>       راه حل برطرف کردن خطای بیضی سفید رنگ: </b>
             
              <br/> 
                       
                            
                        <DialogContentText className={classes.justifyText}>

                        در صورتی که در این بخش، تصویر سلفی خود را مشاهده نمی کنید و صرفا یک بیضی سفید رنگ رویت می شود، می بایست تنظیماتی را به صورت دستی در گوشی یا لب تاپ خود انجام دهید که توضیحات آن در  <b> <a href="https://vidaverify.ir/%d8%a7%d8%ad%d8%b1%d8%a7%d8%b2-%d9%87%d9%88%db%8c%d8%aa-%d8%af%db%8c%d8%ac%db%8c%d8%aa%d8%a7%d9%84-%d8%b3%d8%a7%d9%85%d8%a7%d9%86%d9%87-%d8%ab%d9%86%d8%a7/" rel="noreferrer"> این لینک </a></b> (انتهای صفحه، بخش سوالات متداول، سوال شماره هشت) آمده است.

                        </DialogContentText>
                      

                        <br/>
                        <b style={{ fontSize: '18px', color: 'red' }}>           موارد زیر را رعایت کنید: </b>
             
              
                <li>
                <DialogContentText className={classes.justifyText}>
                  رعایت پوشش و حجاب، برای کلیه کاربران (آقا و خانم) الزامی
                  است.
                  </DialogContentText>
                </li>
                <li>  <DialogContentText className={classes.justifyText}>می بایست کادر بیضی شکل، کاملا منطبق بر چهره تان باشد.</DialogContentText></li>
                <li>  <DialogContentText className={classes.justifyText}>فرد دیگری در کادر مستطیل شکل، نباشد (تمام کادر مستطیل شکل به عنوان تصویر پروفایل در نظر گرفته می شود). </DialogContentText></li>
                <li>  <DialogContentText className={classes.justifyText}>محیط نور کافی داشته باشد. </DialogContentText></li>
                <li>  <DialogContentText className={classes.justifyText}>نور از پشت سر تابیده نشود (نور آفتاب یا چراغ در پشت سر نباشد). </DialogContentText></li>
                <li>  <DialogContentText className={classes.justifyText}>چهره در سایه قرار نگیرد. </DialogContentText></li>
                <li>  <DialogContentText className={classes.justifyText}>به هنگام گرفتن تصویر سلفی، دست لرزش نداشته باشد. </DialogContentText></li>
                
             

                    </ul>

                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)} color="primary">
                        ادامه
                    </Button>
                </DialogActions>
            </Dialog>




            <Snackbar
                open={showSnack}
                autoHideDuration={2000}
                message="لطفا برای تصویر پروفایل، عکس سلفی بگیرید."
                onClose={() => setShowSnack(false)}
            />
        </>
    )
}

export default SelfieImage
